import { render } from "./ArrowNavigation.vue?vue&type=template&id=7df09d23&scoped=true"
import script from "./ArrowNavigation.vue?vue&type=script&lang=js"
export * from "./ArrowNavigation.vue?vue&type=script&lang=js"

import "./ArrowNavigation.vue?vue&type=style&index=0&id=7df09d23&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df09d23"]])

export default __exports__